angular.module('logbook')
.directive('listNavigator', ["$http", "$location", '$route', function($http, $location, $route) {
  return {
    redirect: 'E',

    scope: {
       query: '=',
       objectName: '@',
       populateFields: '=',
       backToList: '=',
       itemProjection: '@'
    },

	template: require('./list-navigator.html'),

    link: function(scope, elem, attrs) {
   
       scope.updateTimeframeParameter = function(query)
       {
          if( query['fromDate'] )
          {
             query['fromTimeframe'] = query['fromDate'];
             delete query['fromDate'];
          }
       };
       
       if( $location.search()['query'])
       {
          scope.query = JSON.parse($location.search()['query']);
          scope.updateTimeframeParameter(scope.query);
          scope.query.size=1;
          if( $location.search()['index']  || $location.search()['index'] == 0 )
             scope.query.page = parseInt($location.search()['index']);
          
          $http.get('/api/'+scope.objectName+'s', {params: scope.query}).then(function(results) {
             scope.page = results.data.page;
             if( !$location.search()[scope.objectName] )
             {
                
                var nextItem = results.data._embedded[scope.objectName+'s'][0];
                scope.exceededListBounds=!nextItem;
                var params = {};
                if( scope.itemProjection )
                   params['projection'] = scope.itemProjection;
                if( nextItem )
                   $http.get(nextItem._links.self.href, { 'params': params})
                      .then(function(result) {
                         scope.populateFields(result.data);
                         scope.currentData = result.data;
                      });
             }
             else
                scope.currentData = results.data._embedded[scope.objectName+'s'][0];
                
          });
       }
       
       scope.changeIndex = function(newIndex, preApproved)
       {
          if( !preApproved )
             $http.get('/api/'+scope.objectName+'s', {params: scope.query}).then(function(results) {
                var item = results.data._embedded[scope.objectName+'s'][0];
                if( item && scope.currentData
                      && item._links.self.href == scope.currentData._links.self.href)
                   scope.changeIndex(newIndex, true);
                else
                   scope.changeIndex(newIndex-1, true);
			 });
		   
          if(preApproved) {
			   $location.search(scope.objectName, null)
				   .search('query', JSON.stringify(scope.query))
				   .search('index', newIndex);
             
                $route.reload();
          }
       }
    }
  }
}]);
